import RouterInteraction from './RouterInteraction';

export { RouterInteraction, RouterInteraction as default };
